import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {GalleryType} from "../../offer/components/quick_view/QWImageWithButton";
import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

const mapQuickViewSidebarClickAlgolytics = delayHit((payload) => hitAlgolytics("offer_list_map", payload), 500);

export const openQuickViewHit = (offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: "quick_view_open",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const closeQuickViewHit = () => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        event_type: "quick_view_close",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const quickViewNextPropertyClick = () => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        event_type: "quick_view_next_click",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const quickViewPrevPropertyClick = () => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        event_type: "quick_view_prev_click",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const quickViewPropertyChange = (offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: "quick_view_property_view",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const moreInfoLinkClick = (offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: "click_more_info",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const galleryButtonClick = (type: GalleryType, offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: `show_${type}`,
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {GalleryType} from "../../offer/components/quick_view/QWImageWithButton";
import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

const mapQuickViewSidebarClickAlgolytics = delayHit((payload) => hitAlgolytics("offer_list_map", payload), 500);

export const openQuickViewHit = (offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: "quick_view_open",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const closeQuickViewHit = () => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        event_type: "quick_view_close",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const quickViewNextPropertyClick = () => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        event_type: "quick_view_next_click",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const quickViewPrevPropertyClick = () => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        event_type: "quick_view_prev_click",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const quickViewPropertyChange = (offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: "quick_view_property_view",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const moreInfoLinkClick = (offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: "click_more_info",
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};

export const galleryButtonClick = (type: GalleryType, offerId: number, propertyId: number) => {
    const payload = {
        view_type: ViewType.OFFER_LIST_MAP,
        offer_id: offerId,
        property_id: propertyId,
        event_type: `show_${type}`,
        modal_name: "quick_view",
        ...getTrackedSiteData()
    };

    mapQuickViewSidebarClickAlgolytics(payload);
};
